export const capitalizeWords = (str) => {
  return str
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export const getOidcItem = () => {
  let oidcItem = null;
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.includes("oidc")) {
      oidcItem = localStorage.getItem(key);
      break;
    }
  }

  return oidcItem

}
